import {config as numberPercentColumnConfig} from '../../common/NumberPercentColumn';

export const prop = 'cROD';

export const config = (labels) =>
	numberPercentColumnConfig({
		id: 'overdue',
		label: labels.overdueLabel,
		prop,
		getPartial: (item) => item[prop],
		getTotal: (item) => item['cRTotal'],
		width: 'minmax(var(--px-130), 1fr)'
	});
